<template>
  <!-- Tam ekran overlay degil: deploy sonrasi acik kalan sekmede alttan cikan, engellemeyen
       kart. Public sayfalarda da (Oturum suresi bitti, Giris) gorunmesi icin App.vue koku
       seviyesinde durur. -->
  <div v-if="surum.goster" role="status" aria-live="polite"
    class="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:left-1/2 sm:-translate-x-1/2 z-[2000]
           sm:w-full sm:max-w-md bg-surface-0 dark:bg-surface-800 border border-surface-200 dark:border-surface-700
           rounded-lg shadow-lg px-4 py-3 flex items-center gap-3">
    <i class="pi pi-info-circle text-primary text-xl flex-shrink-0"></i>
    <div class="text-sm text-gray-700 dark:text-gray-200 flex-1">
      Uygulamanın yeni sürümü yayınlandı. Devam etmek için sayfayı yenileyin.
    </div>
    <Button label="Yenile" icon="pi pi-refresh" class="flex-shrink-0" @click="yeniSurumYenile" />
    <button type="button" aria-label="Kapat" class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 flex-shrink-0"
      @click="surum.goster = false">
      <i class="pi pi-times"></i>
    </button>
  </div>
</template>

<script>
import { yeniSurumState, yeniSurumYenile } from '@/services/yeniSurum';

export default {
  name: 'YeniSurumUyarisi',
  data() {
    return { surum: yeniSurumState };
  },
  methods: {
    yeniSurumYenile,
  },
};
</script>
